module.exports = __webpack_public_path__ + "static/image2-40525947df52e98af2d8aec329205675.jpg";